module.exports = __webpack_public_path__ + "img/COWBOY HAT LIME.2a5a378.svg";